module.exports = __webpack_public_path__ + "media/asset/images/pen-da19388ee980c38c9498b0a5f16bc9d9.svg";